import { Link } from "@inertiajs/react";
import { usePage } from "@inertiajs/react";

import styles from "./PublicLayout.module.css";

export default function PublicLayout({ props, children }) {
  const { current_user } = usePage().props;

  return (
    <>
      <header className={styles.topHeader}>
        <h1>Turista.Club</h1>

        <div className={styles.rightSection}>
          <nav className={styles.navigationMenu}>
            <ul>
              <li>Homepage</li>
              <li>About</li>
            </ul>
          </nav>

          {current_user && (
            <Link href="/sign_out" method="delete">Sign Out</Link>
          )}

          {!current_user && (
            <Link href="/sign_in">Sign in</Link>
          )}
        </div>
      </header>

      <div className="container">
        {children}
      </div>
    </>
  );
}
